(ns frontend.test.validation.model
  (:require [clojure.string :as string]
            [common.util :as cu]
            [potpuri.core :as potpuri]))

(def attribute-defs
  [{:attribute :some/thing
    :label "Some thing"
    :mandatory? true
    :data-type :data.type/text-simple
    :constraints {:constraint/string-min-length 2
                  :constraint/mandatory-fn
                  (fn [field-value entity-data]
                    (cu/blank-value? field-value))
                  :constraint/unique-name :TODO}
    #_#_:not-clearable? true}
   {:attribute :some/date-field
    :label "Some date"
    :mandatory? true
    :data-type :data.type/datetime
    :constraints {:constraint/mandatory-fn
                  (fn [field-value entity-data]
                    (cu/blank-value? field-value))}
    #_#_:not-clearable? true}
   {:attribute :some/ref-field
    :label "Some ref"
    :entity-types [:entity.type/company]
    ;;:mandatory? true
    :data-type :data.type/ref-single
    :constraints {;;:constraint/string-min-length 2
                  :constraint/mandatory-fn
                  (fn [field-value entity-data]
                    (cu/blank-value? field-value))}
    #_#_:not-clearable? true}
   {:attribute :some/percentage
    :label "Some percentage"
    ;;:entity-types [:entity.type/company]
    :mandatory? true
    :data-type :data.type/percentage
    :constraints {:constraint/mandatory-fn
                  (fn [field-value entity-data]
                    (cu/blank-value? field-value))}
    #_#_:not-clearable? true}])

(def attribute-defs-by-attribute
  (->> attribute-defs
       (potpuri/index-by :attribute)))

(def root ::state)
(def root-path [root])

(defn i-root
  [{:keys [ident]}]
  (if (coll? ident)
    (into root-path ident)
    (conj root-path ident)))

(def edits-key :edits)
(def edits-path [edits-key])
(defn edits-full-path
  [ctx]
  (conj (i-root ctx) edits-key))

(defn entity-edits-full-path
  [{:keys [entity-id] :as ctx}]
  (conj (edits-full-path ctx) entity-id))

(def errors-key :errors)
(def errors-path [errors-key])
(defn errors-full-path
  [ctx]
  (conj (i-root ctx) errors-key))

(defn entity-errors-full-path
  [{:keys [entity-id] :as ctx}]
  (conj (errors-full-path ctx) entity-id))

;;; Events
(def update-value ::update-value)
(def clear-state ::clear-state)
;; explicit validation; if passes, save, if fails, display errors
(def try-save ::try-save)

;;; Subscriptions
(def root-state ::root-state)
(def state ::state)
;; all edits under here:
(def edits ::edits)
;; entity-specific edits:
(def entity-edits ::entity-edits)
;; single attribute value for entity-edits:
(def entity-value ::entity-value)
(def entity-value-errors ::entity-value-errors)
(def validate-all ::validate-all)

;; errors explicitly saved to state
(def state-errors ::state-errors)
(def state-entity-errors ::state-entity-errors)
(def state-entity-value-errors ::state-entity-value-errors)
